export default __webpack_public_path__ + "9662131f4f0a53d3f68fa2bd111dead5.svg";